export const KIND_MARKET = 'market'
export const KIND_LIFE_INSURANCE = 'lifeinsurance'
export const KIND_CAPITALISATION = 'capitalisation'
export const KIND_PEA = 'pea'
export const KIND_SAVINGS = 'savings'
export const KIND_PEE = 'pee'
export const KIND_PERCO = 'perco'
export const KIND_PERP = 'perp'
export const KIND_ARTICLE83 = 'article83'
export const KIND_RSP = 'rsp'
export const KIND_CHECKING = 'checking'
export const KIND_CARD = 'card'
export const KIND_DEPOSIT = 'deposit'
export const SAVING_KIND_LIVRET_A = 'livret_a'
export const SAVING_KIND_LIVRET_JEUNE = 'livret_jeune'
export const SAVING_KIND_LDD = 'ldd'
export const SAVING_KIND_PEL = 'pel'
export const SAVING_KIND_CEL = 'cel'
export const SAVING_KIND_LEP = 'lep'
export const KIND_LOAN = 'loan'

export const kindRepartitionWhitelist = [
  KIND_MARKET,
  KIND_LIFE_INSURANCE,
  KIND_CAPITALISATION,
  KIND_PEA,
  KIND_SAVINGS,
  KIND_PEE,
  KIND_PERCO,
  KIND_PERP,
  KIND_ARTICLE83,
  KIND_RSP,
  KIND_CHECKING,
  KIND_CARD,
  KIND_DEPOSIT
]

export const bankContractKinds = [KIND_CHECKING, KIND_CARD, KIND_DEPOSIT]

export const supportedContractKinds = [
  KIND_LIFE_INSURANCE,
  KIND_CAPITALISATION,
  KIND_PEA,
  KIND_PERCO,
  KIND_PERP,
  KIND_PEE,
  KIND_MARKET,
  KIND_SAVINGS,
  KIND_CHECKING,
  KIND_CARD,
  KIND_DEPOSIT,
  KIND_LOAN
]

export const riskedContractKinds = [
  KIND_LIFE_INSURANCE,
  KIND_CAPITALISATION,
  KIND_PEA,
  KIND_MARKET,
  KIND_PERCO,
  KIND_PERP,
  KIND_PEE,
  KIND_ARTICLE83
]

export const supportedSavingsKinds = [
  SAVING_KIND_LIVRET_A,
  SAVING_KIND_LIVRET_JEUNE,
  SAVING_KIND_LDD,
  SAVING_KIND_PEL,
  SAVING_KIND_CEL,
  SAVING_KIND_LEP
]

export const analyzableContracts = [KIND_LIFE_INSURANCE, KIND_CAPITALISATION]

export function isLifeInsurance({ kind }) {
  return kind === KIND_LIFE_INSURANCE || kind === KIND_CAPITALISATION
}

export function isMarket({ kind }) {
  return kind === KIND_MARKET
}

export function isPEA({ kind }) {
  return kind === KIND_PEA
}

export function isRisked({ kind }) {
  return riskedContractKinds.includes(kind)
}

export function isChecking({ kind }) {
  return kind === KIND_CHECKING
}

export function isSupportedKind({ kind }) {
  return supportedContractKinds.includes(kind)
}

export function isSupportedSaving({ kindDetail }) {
  return supportedSavingsKinds.includes(kindDetail)
}

export function isSupported(contract) {
  return (
    isSupportedKind(contract) &&
    (contract.kind !== KIND_SAVINGS || isSupportedSaving(contract))
  )
}

export function getHistoryTime({ history }) {
  return {
    from: history ? new Date(history[0][0]) : Date.now(),
    to: history ? new Date(history[history.length - 1][0]) : Date.now()
  }
}

export function isBankAccount({ kind }) {
  return bankContractKinds.includes(kind)
}

export function isContractTypeAnalyzable({ kind }) {
  return analyzableContracts.includes(kind)
}
